import React, { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import Claim from '../../services/ClaimService';
import dayjs from 'dayjs';

const Dashboard = () => {
  const IntFormatter = new Intl.NumberFormat('ko-KR', { style: 'decimal' });
  const safeFormat = (value) =>
    IntFormatter.format(
      value != null && !Number.isNaN(Number(value)) ? Number(value) : 0
    );
  const [data, setData] = useState({
    performancCount: 0,
    claimCount: 0,
    claimProcessingRate: 0,
    claimReceiptCount: 0,
    claimCompleteCount: 0,
    claimRejectCount: 0,
    claimInsuranceCount: 0,
    claimRepairCount: 0,
    claimRepairCompleteCount: 0,
  });

  const getData = async () => {
    try {
      const data = await Claim.homeInfo();
      if (data) {
        // API 응답의 모든 숫자 필드를 안전하게 처리
        const safeData = {
          performancCount: data.performancCount ?? 0,
          claimCount: data.claimCount ?? 0,
          claimProcessingRate: data.claimProcessingRate ?? 0,
          claimReceiptCount: data.claimReceiptCount ?? 0,
          claimCompleteCount: data.claimCompleteCount ?? 0,
          claimRejectCount: data.claimRejectCount ?? 0,
          claimInsuranceCount: data.claimInsuranceCount ?? 0,
          claimRepairCount: data.claimRepairCount ?? 0,
          claimRepairCompleteCount: data.claimRepairCompleteCount ?? 0,
        };
        setData(safeData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const today = new Date();
  // console.log(today);

  return (
    <Card title="사고 관리" className="dashboard-h p-2">
      <div className="pr-3 pb-2 flex justify-content-end align-items-center gap-2">
        <i className="pi pi-calendar" />
        Today : {dayjs(today).format('YYYY-MM-DD')}
      </div>
      <div className="grid text-center">
        <div className="col-4">
          <Panel header="누적성능점검">
            <div className="text-lg">
              {safeFormat(data.performancCount) + ' 건'}
            </div>
          </Panel>
        </div>
        <div className="col-4">
          <Panel header="누적보증건수">
            <div className="text-lg">
              {safeFormat(data.claimCount) + ' 건'}
            </div>
          </Panel>
        </div>
        <div className="col-4">
          <Panel header="처리율">
            <div className="text-lg">
              {safeFormat(data.claimProcessingRate) + ' %'}
            </div>
          </Panel>
        </div>

        <div className="col-4">
          <Panel header="접수중">
            <div className="text-lg">
              {safeFormat(data.claimReceiptCount) + ' 건'}
            </div>
          </Panel>
        </div>
        <div className="col-4">
          <Panel header="접수완료">
            <div className="text-lg">
              {safeFormat(data.claimCompleteCount) + ' 건'}
            </div>
          </Panel>
        </div>
        <div className="col-4">
          <Panel header="보증거절">
            <div className="text-lg">
              {safeFormat(data.claimRejectCount) + ' 건'}
            </div>
          </Panel>
        </div>
        <div className="col-4">
          <Panel header="진단안내">
            <div className="text-lg">
              {safeFormat(data.claimInsuranceCount) + ' 건'}
            </div>
          </Panel>
        </div>
        <div className="col-4">
          <Panel header="수리진행">
            <div className="text-lg">
              {safeFormat(data.claimRepairCount) + ' 건'}
            </div>
          </Panel>
        </div>
        <div className="col-4">
          <Panel header="비용지급">
            <div className="text-lg">
              {safeFormat(data.claimRepairCompleteCount) + ' 건'}
            </div>
          </Panel>
        </div>
      </div>
    </Card>
  );
};

export default Dashboard;
